import StockModuleSettingCard from './stockModuleSettingCard.container';

export default StockModuleSettingCard;